import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceTaskFormComponent } from './service-task-form.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    ServiceTaskFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    ServiceTaskFormComponent
  ]
})
export class ServiceTaskFormModule { }
